import api from './api.js';

/**
 * Resource posts service wrapper  FYI: Resource is a fancy name for their pdf and other downloadable products.
 */
class InstructorResources {

  /**
     * Constructor
     */
  constructor() {

    // Set URLs
    this.url = '/instructor-resources';
    this.url_categories = '/instructor-resources/categories';
    this.url_tags = '/instructor-resources/tags';
  }

  /**
     * Get all posts (paginated)
     * @param {*} params
     * @return {Promise}
     */
  all(params = {}) {
    return api.get(this.url, params, true);
  }

  /**
     * Get specific post
     * @param {*} post
     * @param {*} params
     * @return {Promise}
     */
  get(post, params = {}) {
    return api.get(this.url + '/' + post, params, true);
  }

  /**
     * Get post categories
     * @param {*} params
     * @return {Promise}
     */
  categories(params = {}) {
    return api.get(this.url_categories, params, true);
  }

  /**
     * Get category and its posts
     * @param {*} category
     * @param {*} params
     * @return {Promise}
     */
  category(category, params = {}) {
    return api.get(this.url_categories + '/' + category, params, true);
  }

  /**
     * Get all tags
     * @param {*} params
     * @return {Promise}
     */
  tags(params = {}) {
    return api.get(this.url_tags, params, true);
  }

  /**
     * Get specific tag & posts
     * @param {*} tag
     * @param {*} params
     * @return {Promise}
     */
  tag(tag, params = {}) {
    return api.get(this.url_tags + '/' + tag, params, true);
  }
}

export default new InstructorResources;
